<div class="video-recorder-container" fxFlex="1 1 60" fxFlex.xs="1 1 auto">
  <div class="video-recorder" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start stretch">
    <div class="cam-view" fxLayoutAlign="start stretch" fxFlex="1 1 250px">
      <video #cameraPlaceholder></video>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="video-recorder-controls">
      <div class="play">
        <mat-icon class="icon-play">pause</mat-icon>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div class="resume"></div>
        <div class="recorder" (click)="initialize()"></div>
        <div class="pause"></div>
      </div>
      <div class="play">
        <mat-icon class="icon-play">play_arrow</mat-icon>
      </div>
    </div>
  </div>
</div>
